import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronUp } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const { dir } = useLanguage();

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      if (scrollY > 150) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          onClick={scrollToTop}
          className="fixed bottom-6 left-5 sm:left-6 z-[70] text-primary-foreground bg-primary hover:bg-primary/90 flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 rounded-full border border-white/20 shadow-xl hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none cursor-pointer"
          aria-label="Scroll to top"
        >
          <ChevronUp size={22} strokeWidth={3} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
